import type { MaybeRefOrGetter, Ref } from 'vue';

import { useElementSize } from '@vueuse/core';
import { computed, toValue } from 'vue';

import type { ChartGeometryOptions } from './chart-geometry';

import { resolveChartGeometry } from './chart-geometry';

export const useChartGeometry = (
  target: Ref<SVGSVGElement | null>,
  options?: MaybeRefOrGetter<ChartGeometryOptions>,
) => {
  const { height, width } = useElementSize(target);
  const geometry = computed(() => resolveChartGeometry(width.value, height.value, toValue(options)));
  const isMeasured = computed(() => width.value > 0 && height.value > 0);

  return {
    geometry,
    isMeasured,
  };
};
